import CryptoJS from 'crypto-js'

const e = (data, key) => {
  if (!data || !key) {
    throw new Error('Data and key must not be null, undefined, or empty')
  }

  try {
    // Generate a random salt
    const salt = CryptoJS.lib.WordArray.random(16)

    // Encrypt data using AES
    const encrypted = CryptoJS.AES.encrypt(data, key, { iv: salt })

    return {
      encrypted: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
      iv: CryptoJS.enc.Base64.stringify(encrypted.iv)
    }
  } catch (error) {
    console.error('Encryption failed:', error)
    throw error
  }
}

export { e }



// WEBPACK FOOTER //
// ./src/commons/aes.js